import styled from '@emotion/styled'
import ClearIcon from '@mui/icons-material/Clear'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import React, { useEffect, useRef } from 'react'
import { fi } from '../../utils/helpers'

const CustomCloseButton = styled(Button)`
	padding: 1px 0 0 2px;
`
const BackDrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 7000;
	background: var(--color-backdrop);
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`

export const ModalContainerBox = styled.div`
	box-sizing: border-box;
	max-width: 760px;
	width: 760px;
	height: auto;
	align-content: center;
	background: var(--color-white);
	border-radius: 4px;
	margin: auto;
	cursor: default;
	box-shadow:
		0 11px 15px -7px rgb(0 0 0 / 20%),
		0px 24px 38px 3px rgb(0 0 0 / 14%),
		0px 9px 46px 8px rgb(0 0 0 / 12%);
`

export const ModalHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: 8px 16px;
	user-select: none;

	.MuiButton-root {
		color: var(--color-monochrome) !important;
	}
`

export const ModalContent = styled.div`
	padding: 16px;
`

export const ModalFooter = styled.div`
	padding: 16px;
	display: flex;
	justify-content: flex-end;
`

type GenericModalProps = {
	title: string
	footer?: React.ReactNode
	children: React.ReactNode
	onClose: (evt) => void
	hasCancel: boolean
}

const GenericModal = (props: GenericModalProps) => {
	const ref: any = useRef()

	const onBlur = (evt) => {
		if (evt.relatedTarget && !ref.current.contains(evt.relatedTarget)) {
			try {
				ref.current.focus()
			} catch (e) {}
		}
	}

	useEffect(() => {
		ref.current.focus()
	}, [ref])

	return (
		// <BackDrop tabIndex={0} onBlur={onBlur} ref={ref}>
		<BackDrop
			onBlur={onBlur}
			ref={ref}
			onClick={props.onClose}
			data-testid="backdrop"
		>
			<ModalContainerBox
				data-testid="modal-container"
				onClick={(e) => e.stopPropagation()}
			>
				<ModalHeader>
					<p className="text-18 text-semiBold" data-testid="modal-title">
						{props.title}
					</p>
					{fi(
						props.hasCancel,
						<CustomCloseButton
							onClick={props.onClose}
							data-testid="modal-close-button"
							title="Close"
							color="secondary"
							size="small"
						>
							<ClearIcon fontSize="small" />
						</CustomCloseButton>
					)}
				</ModalHeader>
				<ModalContent>{props.children}</ModalContent>
				{props.footer && (
					<>
						<Divider />
						<ModalFooter>{props.footer}</ModalFooter>
					</>
				)}
			</ModalContainerBox>
		</BackDrop>
	)
}

export default GenericModal
